/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState } from "react";
import { ClientProfile, User } from "api/types";
import classNames from "classnames";
import ReusableForm from "components/Form";
import { FieldType, FormData } from "components/types";
import { UseFormGetValues, UseFormSetValue, useForm } from "react-hook-form";
import {
  AUSTRALIA_STATE_OPTIONS,
  STREET_TYPE_OPTIONS,
} from "utils/util";

export interface AdminUpdateProps {
  user: User;
  onSubmitFn: (data: FormData) => Promise<void>;
  isSuperAdmin?: boolean;
  refreshData?: () => void;
}

export const getContactDetailsFields = (
  getValue: UseFormGetValues<FormData>,
  setValue: UseFormSetValue<FormData>,
  clientProfile: ClientProfile,
  user: User,
  setResidentialState: (value: string | undefined) => void,
  residentialState: string | undefined,
  watchedFields: FormData,
) => [
  {
    type: FieldType.Paragraph,
    parentFormContainerClassName: "w-full",
    name: "",
    label: "",
    children: (
      <p
        className={classNames(
          "mt-5 text-sm leading-5 font-semibold text-gray-700"
        )}
      >
        Residential address
      </p>
    ),
  },
  {
    name: "residentialAddressUnitNumber",
    label: "Unit number *",
    type: FieldType.Input,
    parentFormContainerClassName:
      "md:w-1/3 w-full inline-block align-top md:pr-6",
    containerClassName: "w-full",
    className: "w-full",
    subType: "number",
  },
  {
    name: "residentialAddressBuildingName",
    label: "Building name",
    type: FieldType.Input,
    parentFormContainerClassName:
      "md:w-1/3 w-full inline-block align-top md:pr-6",
    containerClassName: "w-full",
    className: "w-full",
  },
  {
    name: "residentialAddressState",
    label: "State *",
    type: FieldType.Select,
    placeholder: "Select State/Territory",
    parentFormContainerClassName:
      "md:w-1/3 w-full inline-block align-top md:pr-6",
    containerClassName: "w-full",
    className: "w-full",
    options: AUSTRALIA_STATE_OPTIONS,
  },
  {
    name: "residentialAddressApartmentNumber",
    label: "Apartment number *",
    type: FieldType.Input,
    parentFormContainerClassName:
      "md:w-1/3 w-full inline-block align-top md:pr-6",
    containerClassName: "w-full",
    className: "w-full",
    subType: "number",
  },
  {
    name: "residentialAddressBuildingNumber",
    label: "Building number *",
    type: FieldType.Input,
    parentFormContainerClassName:
      "md:w-1/3 w-full inline-block align-top md:pr-6",
    containerClassName: "w-full",
    className: "w-full",
    subType: "number",
  },
  {
    name: "residentialAddressPostcode",
    label: "Postcode *",
    type: FieldType.Input,
    placeholder: "3001",
    parentFormContainerClassName:
      "md:w-1/3 w-full inline-block align-top md:pr-6",
    containerClassName: "w-full",
    className: "w-full",
    subType: "number",
  },
  {
    name: "residentialAddressSuburb",
    label: "Suburb *",
    type: FieldType.Input,
    placeholder: "Clayton",
    parentFormContainerClassName:
      "md:w-1/3 w-full inline-block align-top md:pr-6",
    containerClassName: "w-full",
    className: "w-full",
  },
  {
    name: "residentialAddressStreetNumber",
    label: "Street number *",
    type: FieldType.Input,
    parentFormContainerClassName:
      "md:w-1/3 w-full inline-block align-top md:pr-6",
    containerClassName: "w-full",
    className: "w-full",
    subType: "number",
  },
  {
    name: "residentialAddressStreetName",
    label: "Street name *",
    type: FieldType.Input,
    placeholder: "Rose Street",
    parentFormContainerClassName:
      "md:w-1/3 w-full inline-block align-top md:pr-6",
    containerClassName: "w-full",
    className: "w-full",
  },
  {
    name: "residentialAddressStreetType",
    label: "Street type *",
    type: FieldType.Select,
    placeholder: "Select street type",
    parentFormContainerClassName:
      "md:w-1/3 w-full inline-block align-top md:pr-6",
    containerClassName: "w-full",
    className: "w-full",
    options: STREET_TYPE_OPTIONS,
  },
  {
    type: FieldType.Paragraph,
    parentFormContainerClassName: "w-full",
    name: "",
    label: "",
    children: (
      <p
        className={classNames(
          "mt-10 mb-3 text-sm leading-5 font-semibold text-gray-700"
        )}
      >
        Mailing address
      </p>
    ),
  },
  {
    name: "mailingAddressSameAsResidentialAddress",
    label: "Same as residential address",
    type: FieldType.Checbox,
    parentFormContainerClassName:
      "md:w-1/1 w-full inline-block align-top md:pr-6",
    containerClassName: "w-full",
    className: "w-full",
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
      if (e.target.checked) {
        setValue("mailingAddressUnitNumber", getValue("residentialAddressUnitNumber"));
        setValue("mailingAddressBuildingName", getValue("residentialAddressBuildingName"));
        setValue("mailingAddressState", getValue("residentialAddressState"));
        setValue("mailingAddressApartmentNumber", getValue("residentialAddressApartmentNumber"));
        setValue("mailingAddressBuildingNumber", getValue("residentialAddressBuildingNumber"));
        setValue("mailingAddressPostcode", getValue("residentialAddressPostcode"));
        setValue("mailingAddressSuburb", getValue("residentialAddressSuburb"));
        setValue("mailingAddressStreetNumber", getValue("residentialAddressStreetNumber"));
        setValue("mailingAddressStreetName", getValue("residentialAddressStreetName"));
        setValue("mailingAddressStreetType", getValue("residentialAddressStreetType"));
      } else {
        setValue("mailingAddressUnitNumber", "");
        setValue("mailingAddressBuildingName", "");
        setValue("mailingAddressState", "");
        setValue("mailingAddressApartmentNumber", "");
        setValue("mailingAddressBuildingNumber", "");
        setValue("mailingAddressPostcode", "");
        setValue("mailingAddressSuburb", "");
        setValue("mailingAddressStreetNumber", "");
        setValue("mailingAddressStreetName", "");
        setValue("mailingAddressStreetType", "");
      }
    }
  },
  {
    name: "mailingAddressUnitNumber",
    label: "Unit number *",
    type: FieldType.Input,
    parentFormContainerClassName:
      "md:w-1/3 w-full inline-block align-top md:pr-6",
    containerClassName: "w-full",
    className: "w-full",
    subType: "number",
  },
  {
    name: "mailingAddressBuildingName",
    label: "Building name",
    type: FieldType.Input,
    parentFormContainerClassName:
      "md:w-1/3 w-full inline-block align-top md:pr-6",
    containerClassName: "w-full",
    className: "w-full",
  },
  {
    name: "mailingAddressState",
    label: "State *",
    type: FieldType.Select,
    placeholder: "Select State/Territory",
    parentFormContainerClassName:
      "md:w-1/3 w-full inline-block align-top md:pr-6",
    containerClassName: "w-full",
    className: "w-full",
    options: AUSTRALIA_STATE_OPTIONS,
  },
  {
    name: "mailingAddressApartmentNumber",
    label: "Apartment number *",
    type: FieldType.Input,
    parentFormContainerClassName:
      "md:w-1/3 w-full inline-block align-top md:pr-6",
    containerClassName: "w-full",
    className: "w-full",
    subType: "number",
  },
  {
    name: "mailingAddressBuildingNumber",
    label: "Building number *",
    type: FieldType.Input,
    parentFormContainerClassName:
      "md:w-1/3 w-full inline-block align-top md:pr-6",
    containerClassName: "w-full",
    className: "w-full",
    subType: "number",
  },
  {
    name: "mailingAddressPostcode",
    label: "Postcode *",
    type: FieldType.Input,
    placeholder: "3001",
    parentFormContainerClassName:
      "md:w-1/3 w-full inline-block align-top md:pr-6",
    containerClassName: "w-full",
    className: "w-full",
    subType: "number",
  },
  {
    name: "mailingAddressSuburb",
    label: "Suburb *",
    type: FieldType.Input,
    placeholder: "Clayton",
    parentFormContainerClassName:
      "md:w-1/3 w-full inline-block align-top md:pr-6",
    containerClassName: "w-full",
    className: "w-full",
  },
  {
    name: "mailingAddressStreetNumber",
    label: "Street number *",
    type: FieldType.Input,
    parentFormContainerClassName:
      "md:w-1/3 w-full inline-block align-top md:pr-6",
    containerClassName: "w-full",
    className: "w-full",
    subType: "number",
  },
  {
    name: "mailingAddressStreetName",
    label: "Street name *",
    type: FieldType.Input,
    placeholder: "Rose Street",
    parentFormContainerClassName:
      "md:w-1/3 w-full inline-block align-top md:pr-6",
    containerClassName: "w-full",
    className: "w-full",
  },
  {
    name: "mailingAddressStreetType",
    label: "Street type *",
    type: FieldType.Select,
    placeholder: "Select street type",
    parentFormContainerClassName:
      "md:w-1/3 w-full inline-block align-top md:pr-6",
    containerClassName: "w-full",
    className: "w-full",
    options: STREET_TYPE_OPTIONS,
  },
];

export default function AdminResidentialAddressAndMailingDetails({
  user,
  onSubmitFn,
  isSuperAdmin,
}: AdminUpdateProps) {
  const { formState, getValues, setValue, watch, ...formMethods } =
    useForm<FormData>();
  const { clientProfile } = user;
  const [residentialState, setResidentialState] = useState<string | undefined>(
    undefined
  );

  const watchedFields = watch(); 

  const onSubmit = async (data: FormData) => onSubmitFn(data);
  
  return (
    <div className="bg-white rounded-md">
      <div className="pl-6 pr-0 pb-0">
        <ReusableForm
          fields={
            getContactDetailsFields(
              getValues,
              setValue,
              clientProfile,
              user,
              setResidentialState,
              residentialState,
              watchedFields,
            )
          }
          onSubmit={onSubmit}
          id="edit-CONTACT_DETAILS"
          formClassName="pt-1 pb-6"
          formMethods={{
            ...formMethods,
            formState,
            getValues,
            setValue,
            watch,
          }}
        />
      </div>
    </div>
  );
}
